export type PublishErrorKind = 'permission_denied' | 'device_unavailable' | 'publish_failed';

/**
 * Maps browser / LiveKit publish failures to honest log labels (not everything is "denied").
 */
export function classifyPublishError(error: unknown): PublishErrorKind {
  const name = error instanceof Error ? error.name : undefined;
  if (name === 'NotAllowedError' || name === 'SecurityError') {
    return 'permission_denied';
  }
  if (name === 'NotFoundError' || name === 'NotReadableError' || name === 'OverconstrainedError') {
    return 'device_unavailable';
  }
  return 'publish_failed';
}
